<div class="animated fadeInRight" style="padding: 24px;">
  <!-- <div class="row no-padding vertical-center" style="font-size: 22px; margin-bottom: 16px;">
  <mat-icon style="font-size: 24px; width:26px;">assignment</mat-icon>&nbsp;{{'Aufträge.title' | translate}}
</div> -->
@if (this.oroservice.kundeninfo?.Standorte?.length > 1) {
  <mat-form-field appearance="fill" class="input-field"
    style="margin-right: 16px;">
    <mat-label>{{'Standort' | translate}}</mat-label>
    <mat-select [(ngModel)]="search.Standort" (selectionChange)="searchClick()">
      <mat-option [value]="-1">{{'Dossier.Alle' | translate}}</mat-option>
      <mat-option [value]="0">{{'Dossier.Keine' | translate}}</mat-option>
      @for (standort of this.oroservice.kundeninfo.Standorte; track standort) {
        <mat-option [value]="standort.Id">
          {{this.oroservice.getStandort(standort?.Id)}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
@if (showPractitioner) {
  <mat-form-field appearance="fill" class="input-field"
    style="margin-right: 16px;">
    <mat-label>{{'Neuauftrag.Behandler' | translate}}</mat-label>
    <mat-select [(ngModel)]="search.Behandler" (selectionChange)="searchClick()">
      <mat-option [value]="-1">{{'Dossier.Alle' | translate}}</mat-option>
      <mat-option [value]="0">{{'Dossier.Keine' | translate}}</mat-option>
      @for (behandler of this.oroservice.kundeninfo.Behandler; track behandler) {
        <mat-option [value]="behandler?.Id">
          {{this.oroservice.getBehandler(behandler?.Id)}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

<button mat-flat-button (click)="selectOrder()" color="primary" class="button-order">
  <mat-icon>assignment</mat-icon>&nbsp;
  {{'Neuauftrag.Einreichen' | translate}}
</button>

@if (this.isLoading) {
  <div>
    <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
  </div>
}

@if (!isLoading && auftraege.length == 0) {
  <div class="row no-padding">
    {{'NoResult' | translate}}
  </div>
}

@if (!isLoading && auftraege.length > 0) {
  <div class="row no-padding">
    <table mat-table [dataSource]="auftraege" style="width: 100%;" class="mat-elevation-z2">
      <ng-container matColumnDef="Datum">
        <mat-header-cell *matHeaderCellDef>{{'Rechnungsdatum' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{element.Rechnungsdatum}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Referenz">
        <mat-header-cell *matHeaderCellDef>{{'Referenz' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{element.Referenz}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Betrag">
        <mat-header-cell *matHeaderCellDef>{{'Betrag' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{element.Betrag | currency:'CHF':'code':'1.2-2'}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Standort">
        <mat-header-cell *matHeaderCellDef>{{'Standort' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{this.oroservice.getStandort(element.GewaehlterStandort)}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Behandler">
        <mat-header-cell *matHeaderCellDef>{{'Neuauftrag.Behandler' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.Behandler) {
            <div>{{element.Behandler.Vorname}}, {{element.Behandler.Name}}</div>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Rechnungsempfaenger">
        <mat-header-cell *matHeaderCellDef>{{'Rechnungsempfaenger' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.Name}}, {{element.Vorname}}<br>{{element.Anschrift1}}<br>{{element.Plz}} {{element.Ort}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Beauftragtam">
        <mat-header-cell *matHeaderCellDef>{{'Beauftragtam' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{element.Datum}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Tools">
        <mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon (click)="this.selectOrder(element)" style="cursor: pointer; margin-right: 4px;">edit</mat-icon>
          <mat-icon (click)="this.showDeleteOrderDialog(element)" style="cursor: pointer;">delete</mat-icon>
          @if (element.DokumentId != 0) {
            <mat-icon (click)="this.oroservice.OpenDocument(element.DokumentId, 'Auftrag')" style="cursor: pointer; margin-right: 4px;">description</mat-icon>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedOrderColumns"></mat-header-row>
      <mat-row *matRowDef="let _; columns: displayedOrderColumns;"></mat-row>
    </table>
  </div>
}
</div>
